import debounce                     from 'lodash.debounce';
import categoryButton               from './faq-form-category-button';

/**
 * FAQ Form
 * The faq form module handles the searching part of the FAQ.
 */
function faqForm(el, faq, app) {
    const $el                       = $(el);
    const baseUrl                   = $el.data('js-faq-form');
    const defaultCount              = $el.data('js-faq-form-count') || 7;
    const $categoryButtonsContainer = $el.find('[data-js-faq-categories]');
    const $spinner                  = $el.find('[data-js-faq-spinner]');
    const $search                   = $el.find('[data-js-faq-search]');
    const $label                    = $el.find('[data-js-faq-label]');
    const $searchClear              = $el.find('[data-js-faq-search-clear]');
    const $commonSearches           = $el.find('[data-js-faq-common-searches]');

    /**
     * renders the category buttons into the
     * container.
     */
    const renderCategoryButtons = function(categories) {
        $el.toggleClass('Ge-FaqForm--Hidden', false);
        $categoryButtonsContainer.empty();
        categories.forEach((category) => {
            let button = categoryButton(category, faq);
            $categoryButtonsContainer.append(button.render());
        });
    };

    $search.on('keydown', (evt) => {
        if (evt.which === 13) {
            evt.preventDefault();
        }
    });

    // attach event listeners
    $search.on('input', debounce(() => {
        let query = $search.val().trim();
        if (query && query.length < 3) { return; }

        // empty string maybe? make it undefined
        if (!query) { query = undefined; }

        faq.setParams({
            query: query,
            commonSearch: undefined,
            category: undefined
        }, { replace: true });

    }, 350));

    $searchClear.click((evt) => {
        evt.preventDefault();
        $search.val('');
        faq.setParams({
            query: undefined,
            commonSearch: undefined,
            category: undefined
        });
        $label.removeClass('Ge-Label--loaded');
        app.trigger('beacon','faq-search-clear');
    });

    // if someone clicks a common search..
    $commonSearches.find('a').click((evt) => {
        evt.preventDefault();
        let commonSearch = $(evt.currentTarget).text();
        $search.val(commonSearch);
        $search.trigger('fieldValidate',[true]);

        faq.setParams({
            query: commonSearch,
            commonSearch: true,
            category: undefined
        });
    });

    faq.on('param:query', (query) => {
        $categoryButtonsContainer.toggleClass('Ge-FaqForm-CategoryButtons--Hidden', !!query);
        $commonSearches.toggleClass('Ge-FaqForm-CommonSearches--Hidden', !!query);
        $searchClear.toggleClass('Ge-Form-Icon--Hidden', !query);
    });

    faq.on('categories', renderCategoryButtons);
    setTimeout(function(el) {
        $search.val(faq.getParams('query'));
        $search.trigger('fieldValidate',[true]);
    }, 0);

    return {};
};

export default faqForm;
